import { parseDefiniteQuotationDTO, QuotationDTO } from 'components/ordering/quotation/api/dtos/quotation-dto.js'
import { StatusCodeToError } from 'components/ordering/quotation/api/dtos/error.js'
import { QuotationStatus } from 'components/ordering/quotation/api/dtos/quotation-status.js'
import {
  formatGroupAcceptedLineIds,
  LineIds
} from 'components/ordering/quotation/api/payloads/group-accepted-line-ids.js'
import { QuotationRequest } from 'components/ordering/quotation/api/quotation-request.js'

const EXPECTED_ERRORS = [400, 404] as const
type ExpectedErrors = StatusCodeToError<typeof EXPECTED_ERRORS[number]>

export type UpdateQuotationPayload = {
  quotationId: number
  status: QuotationStatus
  name?: string
  note?: string
  reasonOfDecline?: string
  groupAcceptedLineIds?: LineIds
}

export class UpdateQuotation extends QuotationRequest<QuotationDTO, ExpectedErrors> {
  path: string
  override expectedErrors = EXPECTED_ERRORS

  constructor({ quotationId, status, name, note, reasonOfDecline, groupAcceptedLineIds }: UpdateQuotationPayload) {
    super()

    this.path = `quotation/${quotationId}/`
    this.init = {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        status: status,
        name: name,
        note: note,
        reason_of_decline: reasonOfDecline,
        group_accepted: formatGroupAcceptedLineIds(groupAcceptedLineIds)
      }),
    }
  }

  override parseResponse = parseDefiniteQuotationDTO
}
